import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    IconButton,
    Tooltip,
    Typography,
    Tabs,
    Tab
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

import { Close } from '@material-ui/icons';

const useStyles = makeStyles(theme => ({
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500]
    },
}));

const ModalComponent = ({
    open,
    onClose,
    title,
    children,
    actions,
    maxWidth = 'sm',
    fullWidth = true,
    paperStyle = {},
    disableTypography = false,
    showTabs = false,
    tabs = [],
    tabsProps = {},
    activeTab = 0,
    onTabChange,
    DialogContentProps = {},
    closeButtonStyle = {},
    ...dialogProps
}) => {
    const classes = useStyles();
    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth={fullWidth}
            maxWidth={maxWidth}
            PaperProps={{ style: paperStyle }}
            {...dialogProps}
        >
            {title && (
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <DialogTitle disableTypography={disableTypography}>
                        {disableTypography ? title : <Typography variant="h6">{title}</Typography>}
                    </DialogTitle>
                    <Tooltip title="Close">
                        <IconButton aria-label="close" className={classes.closeButton} style={closeButtonStyle} onClick={onClose}>
                            <Close />
                        </IconButton>
                    </Tooltip>
                </div>
            )}
            <DialogContent {...DialogContentProps}>
                {showTabs && tabs.length > 0 && (
                    <Tabs
                        value={activeTab}
                        onChange={onTabChange}
                        variant="scrollable"
                        scrollButtons="auto"
                        {...tabsProps}
                    >
                        {tabs.map((tab, idx) => (
                            <Tab key={tab.key || idx} {...tab} />
                        ))}
                    </Tabs>
                )}
                {children}
            </DialogContent>
            {actions && (
                <DialogActions>
                    {actions}
                </DialogActions>
            )}
        </Dialog>
    );
};

export default ModalComponent;
